angular.module('gym.contacts').factory('Contacts', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('contacts');
}]);
